import React from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import type { DRBFMInputPattern, DRBFMStageRun } from '../../../types/drbfm';

interface WorkflowProgressRailProps {
  stageRuns: DRBFMStageRun[];
  inputPattern?: DRBFMInputPattern;
}

type StageDef = [stage: string, labelKey: string, labelJa: string];

const standardStages: StageDef[] = [
  ['extract_changes', 'drbfm.workflow.progress.extractChanges', '変更点抽出'],
  ['normalize_changes', 'drbfm.workflow.progress.normalize', '正規化'],
  ['review_changes', 'drbfm.workflow.progress.review', 'レビュー'],
  ['generate_failure_modes', 'drbfm.workflow.progress.failureModes', '故障モード'],
  ['generate_countermeasures', 'drbfm.workflow.progress.countermeasures', '対策'],
];

const matrixStages: StageDef[] = [
  ['build_function_part_matrix', 'drbfm.workflow.progress.buildMatrix', 'マトリクス作成'],
  ['prefill_function_part_matrix', 'drbfm.workflow.progress.prefillMatrix', 'AI下書き'],
  ['promote_matrix_changes', 'drbfm.workflow.progress.promoteToDesignChange', '設計変更へ昇格'],
  ['review_changes', 'drbfm.workflow.progress.reviewChanges', '変更点レビュー'],
  ['generate_failure_modes', 'drbfm.workflow.progress.failureModes', '故障モード'],
  ['generate_countermeasures', 'drbfm.workflow.progress.countermeasures', '対策'],
];

const WorkflowProgressRail: React.FC<WorkflowProgressRailProps> = ({
  stageRuns,
  inputPattern,
}) => {
  const { t } = useTranslation();
  const statusByStage = new Map(stageRuns.map((run) => [run.stage, run.status]));
  const stages = inputPattern === 'function_part_matrix' ? matrixStages : standardStages;

  return (
    <div className="flex flex-row flex-wrap gap-2">
      {stages.map(([stage, labelKey, labelJa]) => {
        const status = statusByStage.get(stage);
        const label = t(labelKey, labelJa);
        const variant = !status
          ? 'outline'
          : status === 'completed'
            ? 'success'
            : status === 'failed'
              ? 'destructive'
              : 'secondary';
        return (
          <Badge key={stage} variant={variant}>
            {status ? `${label}: ${status}` : label}
          </Badge>
        );
      })}
    </div>
  );
};

export default WorkflowProgressRail;
